<!--
 * @Description:服务管理服务项目服务内容
 * @Author:sunhuihong
 * @Date: 2022-05-23 14:43:52
 * @LastEditTime: 2023-11-27 13:54:59
-->
<template>
  <div>
    <el-row style="margin: 30px 25px 60px 25px; padding-top: 20px;" :gutter="0" type="flex" justify="space-between">
      <el-col :span="16">
        <div style="margin-bottom: 20px;">
          <span class="order-list-title-tag"></span>
          <span class="order-list-title-content">服务项目</span>
        </div>
        <el-form  :model="serviceContentForm" ref="serviceContentForm">
          <el-table :data="serviceContentForm.serviceItemCfgList"  style="border: 1px solid #f0f0f0;"
            :header-cell-style="{ 'text-align': 'left','background-color': '#EFF5FA'}" :cell-style="{'text-align': 'left' }">
            <el-table-column  label="项目名称" min-width="30%" align="left">
              <template slot-scope="scope">
                <el-form-item :prop="'serviceItemCfgList.' + scope.$index + '.name'"
                  :rules="[{required: true, message: '请输入项目名称', trigger: 'blur'},
                  {min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }]">
                  <el-input :disabled="readonly" :readonly="readonly" v-model.trim="scope.row.name" 
                    placeholder="请输入项目名称">
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column  label="项目内容介绍" min-width="70%" align="left">
              <template slot-scope="scope">
                <el-form-item :prop="'serviceItemCfgList.' + scope.$index + '.content'"
                :rules="[{required: true, message: '请输入服务内容', trigger: 'blur'},
                {min: 1, max: 300, message: '长度在 1 到 300 个字符', trigger: 'change' } ]">
                  <el-input placeholder="请输入服务内容" type="textarea" style="width: 85%;" :disabled="readonly" 
                    :readonly="readonly" :rows="2" minlength="1" maxlength="300"  v-model.trim="scope.row.content">
                  </el-input>
                  <el-button type="text" class="delete-style" @click="handleDelete(scope.row,scope.$index)"  
                    :disabled="readonly">
                    <i class="el-icon-delete"></i>
                  </el-button>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
          <div class="add-style">
            <el-button style="width: 100%; height: 100%;" type="text" icon="el-icon-circle-plus-outline" 
              :disabled="readonly" @click="handleAdd" >
              新增一行
            </el-button>
          </div>
        </el-form>
      </el-col>
      <el-col :span="6" >
        <div style="height: 1100px; overflow-y: scroll">
          <img style="width: 100%;" src="@/assets/hsvccfg/app.png"  alt="">
        </div>
      </el-col>
    </el-row>
    <div class="bk-wizard-bottons" style="padding-right: 25px;">
      <wizard-buttons :mode="mode" :status="btnStatus" @btnpressed="handleBtnSelection" />
    </div>
  </div>
</template>
<script>
import hserviseStore from './HserviceDetailStore.js';

let HserviceListServiceContent =  {
  name: 'HserviceListServiceContent',
  hserviseStore,
  
  data() {
    return {
      btnStatus: {'prev': true, 'next': true, 'submit': false},  
      serviceContentForm: {
        serviceItemCfgList: hserviseStore.state.serviceItemCfgList
      }, 
    }
  },
  
  computed: {
    mode() {
      return hserviseStore.state.mode;
    },

    serviceItemData() {
      return hserviseStore.state.serviceItemCfgList;
    },

    readonly() {
      return hserviseStore.state.mode == 'details';
    }  
  },

  methods: {
    //新增
    handleAdd() {
     hserviseStore.state.serviceItemCfgList = hserviseStore.state.serviceItemCfgList || []
     hserviseStore.state.serviceItemCfgList.push({
        "name": '',
        "content":'', 
      })
    },

    // 点击删除
    handleDelete(_row, index) {  
      if (hserviseStore.state.serviceItemCfgList.length > 1) {
        hserviseStore.state.serviceItemCfgList.splice(index, 1)
      } else {
        this.$message.error('服务项目至少有一项')
      } 
    },

    handleBtnSelection(operate) {
      if (this.mode == 'details' || operate != 'next') {
        this.$emit("panel-operate", operate);
        return true;
      }      
      this.$refs.serviceContentForm.validate((valid) => {
        if (!valid) {
          return false
        } else {
          this.$emit("panel-operate", operate);
          return true;
         }
      });
    },
  },  

  destroyed() {
    //销毁的时候同步数据
    hserviseStore.commit('changeServiceItemCfgList', this.serviceItemData);
  },
}
export default HserviceListServiceContent
</script>
<style scoped>
.delete-style {
  color:#e04a52;
  width:20px;
  height:20px;
  line-height: 50px;
  margin-left: 24px;
}

.add-style {
  background-color: #EFF5FA;
  margin: 11px 0 35px 0;
  text-align: center;
  line-height: 24px;
}

.title-tag {
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #2A97FF;
  border-radius: 2px;
  margin-right: 9px;
  vertical-align: middle;
} 

.title-content {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  vertical-align: middle;
}
</style>





// WEBPACK FOOTER //
// src/components/hsvcmng/components/hservicedetails/ServiceContentPanel.vue